import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { DialogLayoutModule } from "@obg/mat.ui.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { ForgotPasswordEmailUiModule } from "../forgot-password-email/forgot-password-email.module";

import { LgForgotPasswordContainer } from "./lg-forgot-password.container";

const DIRECTIVES = [LgForgotPasswordContainer];

@NgModule({
	imports: [CommonModule, MatButtonModule, DialogLayoutModule, CoreContentModule, ForgotPasswordEmailUiModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LgForgotPasswordUiModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, LgForgotPasswordContainer);
	}
}
